import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

@Injectable()
export class VerticalService {
  baseHref = environment.dashboardBaseRef;

  constructor(private http: HttpClient) {}

  // Fetch all vertical categories (name and url)
  fetchAllVerticalsCategories(): Observable<any> {
    const url = `${this.baseHref}api/verticals/overview`;
    return this.http.get<any>(url);
  }
}
